{
  "CSServiceForms": {
    "retrieveFeedback": {
      "page": {
        "refundCaseNotSupportedNotification": "You entered a refund request case number. Please retrieve your case through the <a data-contentid=\"2664822\" href=\"/en/customer-care-and-contact-information/contact-and-request-forms/refund-status\">refund status form</a>."
      }
    }
  },
  "serviceForms": {
    "joinCorporateForm": {
      "fields": {
        "iataNumber": {
          "pattern": "IATA number can contain only 7 or 8 digits."
        }
      }
    }
  }
}
